export enum Position {
  Before = -1,
  After = 1
}
